import { render, staticRenderFns } from "./ChatSearchBar.vue?vue&type=template&id=4c3b3218&"
import script from "./ChatSearchBar.vue?vue&type=script&lang=js&"
export * from "./ChatSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports